import {course_getCourseClasses_Api, course_getCourseClassStudents_Api, course_getCourses_Api,} from 'apis'
import {getId} from 'apis/model/base'
import classNames from 'classnames'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback} from 'react'
import {NullAsDefault} from 'views/Shared'
import {course_getCourseSubjects_Api} from "../../../../../apis";
import {API_ROOT_URL} from "../../../../../envs/_current/config";
import {getTokenKey} from "../../../../../helpers/localStorage";
import DebounceSelect from "../../../../../components/LookupField/DebounceSelect";
import {renderIf} from "../../../../Shared";
import {Avatar} from "antd";
import getAliasName from "../../../../../helpers/getAliasName";
import {FaUserGraduate} from "react-icons/fa6";


const renderOptionItem = (item) => {

    return (
        {
            id: item?.id,
            value: getId(item),
            label: (
                <div className="flex items-center gap-2">
                    {renderIf(
                        item._type === 'student',
                        <Avatar
                            size={28}
                            src={item?.avatar}
                            icon={<FaUserGraduate size={12} className="text-color-500"/>}
                            className="flex flex-center background-200"
                        />
                    )}
                    <div className="font-medium text-sm text-color-000">
                        {getAliasName(item, 'patron_saint') || ''}
                        {' '}
                        {getTitle(item)}
                    </div>
                </div>
            ),
        }
    )
}

export const fetchCourses =
    ({owner_id, owner_type}) =>
        async (type, keyword) => {
            const response = await fetch(
                API_ROOT_URL + course_getCourses_Api.path
                    .replace(":type", owner_type)
                    .replace(":id", owner_id)
                + `?keyword=${keyword}`,
                {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${getTokenKey()}`,
                        'Content-Type': 'application/json',
                    },
                }
            )
            const body = await response.json()
            return Array.from(_.get(body, 'data') || []).map(renderOptionItem)
        }

export const fetchSubjectsInCourse =
    ({course_id}) =>
        async (type, keyword) => {
            const response = await fetch(
                API_ROOT_URL + course_getCourseSubjects_Api.path
                    .replace(":id", course_id)
                + `?keyword=${keyword}`,
                {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${getTokenKey()}`,
                        'Content-Type': 'application/json',
                    },
                }
            )
            const body = await response.json()
            return Array.from(_.get(body, 'data') || []).map((e) => renderOptionItem(e.subject))
        }

export const fetchClassesInCourse =
    ({course_id}) =>
        async (type, keyword) => {
            const response = await fetch(
                API_ROOT_URL + course_getCourseClasses_Api.path
                    .replace(":id", course_id)
                + `?keyword=${keyword}`,
                {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${getTokenKey()}`,
                        'Content-Type': 'application/json',
                    },
                }
            )
            const body = await response.json()
            return Array.from(_.get(body, 'data') || []).map(renderOptionItem)
        }


export const fetchStudentsInClass =
    ({course_class_id}) =>
        async (type, keyword) => {
            const response = await fetch(
                API_ROOT_URL + course_getCourseClassStudents_Api.path
                    .replace(":id", course_class_id)
                + `?keyword=${keyword}`,
                {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${getTokenKey()}`,
                        'Content-Type': 'application/json',
                    },
                }
            )
            const body = await response.json()
            return Array.from(_.get(body, 'data') || []).map((e) => renderOptionItem(e.student))
        }


export const CourseClassStudentAttendanceSheetReportFilter = ({
    owner_id,
    owner_type,
    className = "",
    value: filter = {
        course_id: undefined,
        subject_id: undefined,
        student_id: undefined,
        course_class_id: undefined,
    },
    onChange: setValues = NullAsDefault,
}) => {
    const t = useTranslate()

    const handleChange = useCallback(
        (name, value) => {
            const params = {
                ...filter,
                [name]: value,
            }
            setValues(params)
            return params
        },
        [filter]
    )

    return (
        <div className="flex flex-col items-center gap-2 mt-2">
            <div className="flex items-center gap-2 w-full">
                <div className="text-sm text-color-400 italic whitespace-no-wrap">
                    {`${t('course')} : `}
                </div>
                <DebounceSelect
                    name={"course_id"}
                    type={"course_id"}
                    value={filter.course_id}
                    className={classNames('w-full', className)}
                    notFoundContent={undefined}
                    onChange={(value, option) => {
                        if (value !== filter.course_id) {
                            const next = handleChange("course_id", value)
                            setValues({
                                ...(next ?? {}),
                                subject_id: undefined,
                                course_class_id: undefined
                            })
                        }
                    }}
                    fetchOptions={fetchCourses({
                        owner_id,
                        owner_type,
                    })}
                />
            </div>
            {renderIf(
                filter.course_id,
                <div className="flex items-center gap-2 w-full">
                    <div className="text-sm text-color-400 italic whitespace-no-wrap">
                        {`${t('subjects')} : `}
                    </div>
                    <DebounceSelect
                        name={"subject_id"}
                        type={"subject_id"}
                        value={filter.subject_id}
                        className={classNames('w-full', className)}
                        notFoundContent={undefined}
                        onChange={(value, option) => {
                            if (value !== filter.subject_id) {
                                const next = handleChange("subject_id", value)
                                setValues({
                                    ...filter,
                                    ...(next ?? {}),
                                })
                            }
                        }}
                        fetchOptions={fetchSubjectsInCourse({
                            course_id: filter.course_id
                        })}
                    />
                </div>
            )}

            {renderIf(
                filter.course_id,
                <div className="flex items-center gap-2 w-full">
                    <div className="text-sm text-color-400 italic whitespace-no-wrap">
                        {`${t('classes')} : `}
                    </div>
                    <DebounceSelect
                        name={"course_class_id"}
                        type={"course_class_id"}
                        value={filter.course_class_id}
                        className={classNames('w-full', className)}
                        notFoundContent={undefined}
                        onChange={(value, option) => {
                            if (value !== filter.course_class_id) {
                                const next = handleChange("course_class_id", value)
                                setValues({
                                    ...filter,
                                    ...(next ?? {}),
                                })
                            }
                        }}
                        fetchOptions={fetchClassesInCourse({
                            course_id: filter.course_id
                        })}
                    />
                </div>
            )}

            {renderIf(
                filter.course_class_id,
                <div className="flex items-center gap-2 w-full">
                    <div className="text-sm text-color-400 italic whitespace-no-wrap">
                        {`${t('student')} : `}
                    </div>
                    <DebounceSelect
                        size="large"
                        name={"student_id"}
                        type={"student_id"}
                        value={filter.student_id}
                        className={classNames('w-full', className)}
                        notFoundContent={undefined}
                        onChange={(value, option) => {
                            if (value !== filter.student_id) {
                                const next = handleChange("student_id", value)
                                setValues({
                                    ...filter,
                                    ...(next ?? {}),
                                })
                            }
                        }}
                        fetchOptions={fetchStudentsInClass({
                            course_class_id: filter.course_class_id
                        })}
                    />
                </div>
            )}
        </div>
    )
}

export default CourseClassStudentAttendanceSheetReportFilter
